import { ManifestRuntimeContextBuilder } from './ManifestRuntimeContextBuilder';
import { ManifestContextAPI } from './ManifestContextAPI';
export class ManifestContextAPIProvider {
  constructor(manifestQueryAPI, manifestResolverAPI, manifestStore, editorPointerAPI) {
    this.manifestQueryAPI = manifestQueryAPI;
    this.manifestResolverAPI = manifestResolverAPI;
    this.manifestStore = manifestStore;
    this.editorPointerAPI = editorPointerAPI;
  }
  getManifestQueryAPI() {
    return this.manifestQueryAPI;
  }
  getManifestResolverAPI() {
    return this.manifestResolverAPI;
  }
  getContextBuilder() {
    return new ManifestRuntimeContextBuilder(this.manifestQueryAPI, this.manifestResolverAPI, this.manifestStore, this.editorPointerAPI);
  }
  getContext(editorPointer) {
    const builder = this.getContextBuilder();
    builder.withRuntimeMappings(false);
    builder.byEditorPointer(editorPointer, (manifest, q) => {
      builder.withEditorElement(editorPointer, manifest);
    });
    return new ManifestContextAPI(this.manifestQueryAPI, this.manifestResolverAPI, builder.build('manifest-context-service-build'));
  }
  getResolver(editorPointer) {
    return this.getContext(editorPointer).resolver;
  }
  getQuery(editorPointer) {
    return this.getContext(editorPointer).query;
  }
}
//# sourceMappingURL=ManifestContextAPIProvider.js.map